import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import TopBanner from "@/components/TopBanner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import Home from "@/pages/Home";
import { ServicesList, ServiceDetail } from "@/pages/Services";
import { ZonesList, ZoneDetail } from "@/pages/Zones";
import { BlogList, Article } from "@/pages/Blog";
import { InsectsHub, InsectDetail } from "@/pages/Insects";
import Certifications from "@/pages/Certifications";
import Videos from "@/pages/Videos";
import FAQPage from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Avis from "@/pages/Avis";
import NotreSociete from "@/pages/NotreSociete";
import Devis from "@/pages/Devis";
import Galerie from "@/pages/Galerie";
import Photos from "@/pages/Photos";
import LocalFAQ from "@/pages/LocalFAQ";
import SalonMedocImmo from "@/pages/SalonMedocImmo";
import MentionsLegales from "@/pages/MentionsLegales";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#F9F8F6]">
      <BrowserRouter>
        <ScrollToTop />
        <TopBanner />
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesList />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/zones" element={<ZonesList />} />
            <Route path="/zones/:city" element={<ZoneDetail />} />
            <Route path="/insectes-xylophages" element={<InsectsHub />} />
            <Route path="/insectes-xylophages/:slug" element={<InsectDetail />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/questions-frequentes-locales" element={<LocalFAQ />} />
            <Route path="/salon-medoc-immo-2027" element={<SalonMedocImmo />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<Article />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/avis" element={<Avis />} />
            <Route path="/notre-societe" element={<NotreSociete />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Chatbot />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
